export default "__VITE_ASSET__ba3282bf__"